import { Loading } from '@library/components/Loading';
import { PrimaryButton } from '@library/components/buttons/PrimaryButton';
import { SecondaryButton } from '@library/components/buttons/SecondaryButton';
import { classNames } from '@library/utils';

export interface ActionButtonProps {
  disabled?: boolean;
  label?: string;
  title?: string;
  onClick: () => void | Promise<void>;
}

export interface FormActionButtonsProps {
  className?: string;
  isLoading?: boolean;
  primary: ActionButtonProps;
  secondary: ActionButtonProps;
}

export const FormActionButtons = ({
  className = '',
  isLoading = false,
  primary,
  secondary
}: FormActionButtonsProps) => {
  const primaryButtonLabel = primary.label ?? 'Save';
  const secondaryButtonLabel = secondary.label ?? 'Cancel';

  return (
    <div
      className={classNames(
        'border-soFresh-140 flex items-center justify-end gap-4 border-t border-solid py-3 pr-5',
        className
      )}
    >
      {isLoading && <Loading className="py-1" loadingMessage="" />}
      <SecondaryButton
        title={secondary.title ?? 'Cancel'}
        handleOnClick={secondary.onClick}
        disabled={secondary.disabled}
        testId={`${secondaryButtonLabel}-button`}
      >
        {secondaryButtonLabel}
      </SecondaryButton>
      <PrimaryButton
        title={primary.title ?? 'Save'}
        handleOnClick={primary.onClick}
        disabled={primary.disabled}
        testId={`${primaryButtonLabel}-button`}
      >
        {primaryButtonLabel}
      </PrimaryButton>
    </div>
  );
};
